import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stat } from 'fs';

interface Column {
  label: string;
  value: string;
  checked?: boolean;
}
interface SourceTable {
  value: string;
  label: string;
  checked: boolean;
  selectedColumns: Column[];
  alias?: string;
  allColumns: Column[];
}

interface StreamModel {
  id: any;
  streamType: string
  prevStream: number;
  config: any;
}

interface GeneralSettings {
  name: string;
  description: string;
}

interface ModalState {
  dataSourcePopup: boolean;
  editSourcePopup: boolean;
  selectedDataSources: any;
  generalSettings: GeneralSettings
  currentlySelectedStream: number;
  streams: any,
  isValidationReq?: boolean;
  action: any;
  isNextBtnRequired: boolean;
  isStreamInValid?: any;
}

const initialState: ModalState = {
  dataSourcePopup: false,
  editSourcePopup: false,
  selectedDataSources: [],
  generalSettings: { name: "", description: "" },
  currentlySelectedStream: 0,
  streams: [],
  action: null,
  isValidationReq: false,
  isNextBtnRequired: true,
  isStreamInValid: { join: false, standardization: false, filter: false, incrementalLogic: false, sort: false, derivedColumns: false, encryption: false, masking: false, datatypeValidation: false, union: false, fillNulls: false, deduplication: false, deduplicationMain: false },
};


const onePlatformPipelineSlice = createSlice({
  name: 'onePlatformPipelineSlice',
  initialState,
  reducers: {
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setIsNextBtnRequired: (state, action) => {
      state.isNextBtnRequired = action.payload;
    },
    checkStreamValidations: (state, action: PayloadAction<any>) => {
      state.isStreamInValid = action.payload;
    },
    openDatasourceModal: (state) => {
      state.dataSourcePopup = true;
    },
    closeDatasourceModal: (state) => {
      state.dataSourcePopup = false;
    },
    addGeneralSettings: (state, action: PayloadAction<GeneralSettings>) => {
      state.generalSettings = action.payload;
    },

    addSelectedDatasource: (state, action: PayloadAction<any[]>) => {
      state.selectedDataSources = action.payload;
    },
    updateJoinStream: (state, action) => {
      const { streamId, joinPrevStreamIds, joinTableNames } = action.payload;
      const streamIndex = state.streams.findIndex((s: any) => s.streamID === streamId);
      if (streamIndex != -1) {
        state.streams[streamIndex].joinPrevStreamIds = joinPrevStreamIds;
        state.streams[streamIndex].joinTableNames = joinTableNames;
      }
    },

    appendSelectedDatasource: (state, action: PayloadAction<any>) => {
      const newDataSources = action.payload;
      state.selectedDataSources = {
        ...state.selectedDataSources,
        ...newDataSources,
      };
    },
    addStreams: (state, action: PayloadAction<any[]>) => {
      const newStreams = action.payload.map((connection, index) => ({
        name: `stream${index + 1}`,
        // streamID: connection.id,
        title: `Source_${index + 1}`,
        streamID: 100 + index,
        connection_name: `Source_${index + 1}||${connection.connection_name}`,
        connectionID: `Source_${index + 1}||${connection.id}`,
        datasource_name: `Source_${index + 1}||${connection.datasource_name}`,
        datasource: connection.datasource ? connection.datasource : connection.datasource_name,
        label: `Source_${index + 1}||${connection.label}`,
        type: connection.type,  // Type comes from the payload
        prevStream: connection.prevStream || null,  // PrevStream comes from the payload or null
        config: connection?.config?.length ? connection.config : [],
        fileType: connection?.fileType,
        layer: connection?.layer,
        isRecursive: connection?.isRecursive,
        rootDirectory: connection?.rootDirectory,
        lakeHouseType: connection?.lakeHouseType || null,
        lakehouseconfigdata: connection?.lakehouseconfigdata ? connection?.lakehouseconfigdata : null,
        selectedConfigs: connection?.selectedConfigs?.length > 0 ? connection?.selectedConfigs : null,
        flag: connection?.flag ? connection?.flag : 0,
      }));
      state.streams = [...newStreams];
    },

    addStream: (state, action: PayloadAction<any>) => {
      if (action.payload.type === "partition_output" && action.payload?.partitionColumnName) {
        const duplicatePartition = state?.streams?.find(
          (stream: any) => stream.partitionColumnName === action.payload.partitionColumnName
        );

        if (duplicatePartition) {
          return;
        }
      }

      const prvStreamsIndex = state.streams?.findIndex((item: any) => item.streamID == action.payload.prevStream)
      state.streams.forEach((stream: any) => {
        stream.isActive = false;
      });
      const maxStreamID = Math.max(...state.streams.map((stream: any) => stream.streamID));
      const newStream = {
        name: `stream${1 + maxStreamID}`,
        streamID: 1 + maxStreamID,
        type: action.payload.type,  // Type from the payload
        prevStream: action.payload.prevStream,  // Previous stream ID from the payload
        config: action.payload.type == "partition_output" ? action?.payload?.config : [],  // Empty array for new stream
        connectionID: action.payload.connectionID,
        title: action.payload?.type === "target" ? "Target" : `Source_${1 + maxStreamID}`,
        isActive: true,
        sourceTableName: action.payload.sourceTableName ? action.payload.sourceTableName : undefined,
        partitionColumnName: action.payload.partitionColumnName ? action.payload.partitionColumnName : state?.streams[prvStreamsIndex] ? state?.streams[prvStreamsIndex]?.partitionColumnName : undefined,
        partitionParentId: action.payload?.type == "partition_output" ? action.payload?.prevStream : undefined
      };
      state.streams.splice(prvStreamsIndex + 1, 0, newStream);
      // state.streams.push(newStream);
      const targetIndex = state?.streams?.findIndex((stream: any) => stream.type === "target");
      const findLastStreamIndex: any = (streams: any, prevStreamID: any) => {
        const currentStreamIndex = streams.findIndex((stream: any) => stream.prevStream === prevStreamID && stream.type != "target");
        if (currentStreamIndex === -1) {
          return -1;
        }
        const currentStream = streams[currentStreamIndex];
        const nextStreamID = currentStream.streamID;
        const nextStreamIndex = findLastStreamIndex(streams, nextStreamID);
        return nextStreamIndex === -1 ? currentStreamIndex : nextStreamIndex;
      };
      if (targetIndex != -1) {
        console.log('targetIndex', targetIndex)
        const targetObject = state.streams[targetIndex];
        state?.streams?.splice(targetIndex, 1)
        const expectedStreamIndex = findLastStreamIndex(state?.streams, targetObject?.prevStream);
        if(expectedStreamIndex != -1) {
          state?.streams?.splice(expectedStreamIndex + 1, 0, targetObject)
        } else {
          state?.streams?.splice(targetIndex, 0, targetObject)
        }

      }
      state.streams = state.streams.map((stream: any, index: any, array: any) => {
        // If the type is 'datasource', prevStream should be null
        if (stream.type === 'datasource') {
          return { ...stream, prevStream: null };
        } else if (stream.type === 'partition_output') {
          return { ...stream, prevStream: stream?.partitionParentId };
        } else {
          // Otherwise, set prevStream to the streamID of the previous stream
          const prevStream = index > 0 ? array[index - 1] : {};
          const prevStreamType = prevStream ? prevStream?.type : null;
          const prevStreamID = prevStream ? prevStream?.streamID : null;
          return { ...stream, prevStream: prevStreamID};
        }
      });
      if (newStream.type !== 'partition_output') {
        state.currentlySelectedStream = newStream.streamID;
      }
    },
    appendStreams: (state, action: PayloadAction<any[]>) => {
      const startIndex = Object.keys(state.selectedDataSources)?.length;
      console.log("actionpayload", action.payload, startIndex)
      const maxStreamID = Math.max(...state.streams.map((stream: any) => stream.streamID));

      const newStreams = action.payload.map((connection, index) => {
        console.log("here43 state", state);
        console.log("here43 state.selectedDataSources", state.selectedDataSources);
        console.log("here43 connection", connection, maxStreamID);

        return ({
          name: `stream${maxStreamID + index + 1}`,
          streamID: maxStreamID + index + 1,
          type: connection.type,
          prevStream: connection.prevStream,
          config: [],
          connection_name: `Source_${Object.keys(state.selectedDataSources)?.findIndex((item: any) => item == connection.id) + 1}||${connection.connection_name}`,
          // connection_name: connection.connection_name,
          connectionID: `Source_${Object.keys(state.selectedDataSources)?.findIndex((item: any) => item == connection.id) + 1}||${connection.id}`,
          datasource_name: `Source_${Object.keys(state.selectedDataSources)?.findIndex((item: any) => item == connection.id) + 1}||${connection.datasource_name}`,
          // datasource_name: connection.datasource_name,
          datasource: connection.datasource ? connection.datasource : connection.datasource_name,
          title: `Source_${Object.keys(state.selectedDataSources)?.findIndex((item: any) => item == connection.id) + 1}`,
          isActive: false,
          fileType: connection?.fileType,
          layer: connection?.layer,
          lakeHouseType: connection?.lakeHouseType,
          isRecursive: connection?.isRecursive,
          rootDirectory: connection?.rootDirectory,
          lakehouseconfigdata: connection?.lakehouseconfigdata || null,
          selectedConfigs: connection?.selectedConfigs?.length > 0 ? connection?.selectedConfigs : null,
          flag: connection?.flag ? connection?.flag : 0,

        })
      });
      state.streams = [...state.streams, ...newStreams];
    },
    resetPipelineState: (state) => {
      return initialState;
    },
    deleteStream: (state, action: PayloadAction<number>) => {

      const streamIDToDelete = action.payload;

      const indexToDelete = state.streams.findIndex((stream: any) => stream.streamID === streamIDToDelete);

      if (indexToDelete === -1) return;

      const prevStreamOfDeleted = state.streams[indexToDelete].prevStream;
      const nextStreamID = state.streams?.find((item: any) => item?.prevStream == streamIDToDelete)?.streamID;

      const restStream = state.streams?.filter((stream:any) => stream.streamID !== streamIDToDelete);
      const modifiedStreams = restStream?.map((stream: any) => {
        if(stream.streamID !== nextStreamID) {
          return stream;
        } else {
          return {...stream, prevStream: prevStreamOfDeleted}
        }
      });
      state.streams = modifiedStreams;


    },
    deleteStreampartition: (state, action: PayloadAction<number | number[]>) => {
      const streamIDsToDelete = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];

      // Filter out all streams to be deleted in a single operation
      state.streams = state.streams?.filter(
        (stream: any) => !streamIDsToDelete.includes(stream.streamID)
      );
    },
    addItem: (state, action: PayloadAction<any[]>) => {
      console.log("here")
    },
    isActiveStream: (state, action: PayloadAction<any>) => {

      state.streams = state.streams.map((stream: any) =>
        stream.streamID === action.payload ? { ...stream, isActive: !stream.isActive } : { ...stream, isActive: false }
      );
    },
    removeItem: (state, action: PayloadAction<any>) => {
      console.log("rewmove")
    },
    updateStreamTitle: (state, action: PayloadAction<{ streamID: any; newTitle: string }>) => {
      const { streamID, newTitle } = action.payload;
      state.streams = state.streams.map((stream: any) =>
        stream.streamID === streamID ? { ...stream, title: newTitle } : stream
      );
    },
    updateItemSelection: (state, action: PayloadAction<any>) => {
      const { id } = action.payload;
      const updatedDataSources = { ...state.selectedDataSources };
      Object.keys(updatedDataSources).forEach(key => {
        const connection = updatedDataSources[key];
        if (connection.ConnectionID === id) {
          updatedDataSources[key] = { ...connection, isSelected: !connection.isSelected };
        }
      });

      state.selectedDataSources = updatedDataSources;

    },
    saveSelectedSourceTables: (state, action: PayloadAction<{ id: any; selectedSourceTables: SourceTable[], isActiveStateChangeRequired: boolean, allSourceTables: any[],schema?:any }>) => {

      const { id, selectedSourceTables, isActiveStateChangeRequired, allSourceTables,schema } = action.payload;

      state.streams = state.streams.map((stream: any) => ({
        ...stream,
        isActive: !isActiveStateChangeRequired && stream.streamID === id ? true : false, // Set isActive to false for all streams
        config: stream.streamID === id ? selectedSourceTables : stream.config,
        allSourceTables: stream?.streamID === id ? allSourceTables : stream?.allSourceTables,
        schema: stream?.streamID === id ? schema : stream?.schema,
      }));
      if (isActiveStateChangeRequired) {
        state.currentlySelectedStream = 0;
      } // Set currentlySelectedStream to 0

    },
    saveStreamConfigs: (state, action: PayloadAction<{ id: any; data: any[]; label?: any }>) => {

      const { id, data, label } = action.payload;

      state.streams = state.streams.map((stream: any) => ({
        ...stream,
        isActive: stream.streamID === id ,// Set isActive to false for all streams
        config: stream.streamID === id ? data : stream.config,
      }));

      if (label !== "target") {
        state.currentlySelectedStream = id; 
      }

    },
    saveMappingConfig: (state, action: PayloadAction<{ id: any; data: any; label?: any }>) => {
      const { id, data, label } = action.payload;

      state.streams = state.streams.map((stream: any) => {
        if (stream.streamID === id) {
          return {
            ...stream,
            isActive: false,
            config: [
              {
                ...stream.config?.[0],
                outputStreamName: stream.config?.[0]?.outputStreamName ?? '',
                mapping: data,
              }
            ],
          };
        }
        return stream;
      });

      // state.currentlySelectedStream = 0;
    },

    // saveMappingConfig: (state, action: PayloadAction<{ id: any; data: any; label?: any }>) => {
    //   const { id, data } = action.payload;

    //   state.streams = state.streams.map((stream: any) => {
    //     if (stream.streamID === id) {
    //       const updatedConfig = stream?.config.map((configItem: any) => {
    //         if (configItem.hasOwnProperty('mapping')) {
    //           return { ...configItem, mapping: data };
    //         }
    //         return configItem;
    //       });

    //       return {
    //         ...stream,
    //         isActive: false,
    //         config: updatedConfig,
    //       };
    //     }

    //     return stream;
    //   });

    //   state.currentlySelectedStream = 0;
    // },


    setSelectedStream: (state, action: PayloadAction<any>) => {
      if (state.currentlySelectedStream !== 0) {
        state.currentlySelectedStream = 0;
      } else {
        state.currentlySelectedStream = action.payload;
      }
    },

    saveJoinConfig: (state, action: PayloadAction<{ dataSourceId: any, values: any }>) => {
      // const { dataSourceId, values } = action.payload;
    },
    setSelectedAndActiveStream: (state, action: PayloadAction<number>) => {
      const streamId = action.payload;
      let isActiveFound = false;

      state.streams = state.streams.map((stream: any) => {
        if (stream.streamID === streamId) {
          isActiveFound = !stream.isActive;
          return { ...stream, isActive: !stream.isActive };
        } else {
          return { ...stream, isActive: false };
        }
      });

      state.currentlySelectedStream = isActiveFound ? streamId : 0;
    },
    deactivateAllStreams: (state) => {
      state.streams = state.streams?.map((stream: any) => ({
        ...stream,
        isActive: false,
      }));
      state.currentlySelectedStream = 0;
    },

    setActiveConfig: (state, action: PayloadAction<{ streamID: number, configValue: string }>) => {
      const { streamID, configValue } = action.payload;
      console.log(state.streams)
      state.streams = state?.streams?.map((stream: any) => {
        if (stream?.streamID === streamID) {
          stream.config = stream?.config?.map((cfg: any) => ({
            ...cfg,
            isActive: cfg.value === configValue,
          }));
        } else {
          stream.config = stream?.config?.map((cfg: any) => ({
            ...cfg,
            isActive: false,
          }));
        }
        return stream;
      });
    },
    resetState: (state) => {
      const { isNextBtnRequired } = state;
      return {
        ...initialState,
        isNextBtnRequired,
      };
    },
    deleteStreamByConnectionID: (state, action: PayloadAction<number>) => {
      const connectionIDToDelete = action.payload;
      state.streams = state.streams.filter((stream: any) => stream.connectionID !== connectionIDToDelete);
    },
    deleteStreamByPartitionColumnName: (state, action: PayloadAction<any>) => {
      const partitionColumnNameToDelete: any[] = action.payload;
      state.streams = state.streams.filter((stream: any) => !partitionColumnNameToDelete?.includes(stream.partitionColumnName));
    },
    validationOnStreamReq: (state, action: PayloadAction<any>) => {
      state.isValidationReq = action.payload
    },
    updateStreams: (state, action: PayloadAction<any>) => {
      state.streams = action.payload
    },
    updateStreamsByConfig: (state, action: PayloadAction<any>) => {
      state.streams = action.payload
    },
    patchPipelineData: (state, action: PayloadAction<any>) => {
      state.dataSourcePopup = action?.payload?.dataSourcePopup;
      state.editSourcePopup = action?.payload?.editSourcePopup;
      state.selectedDataSources = action?.payload?.selectedDataSources;
      state.generalSettings = action?.payload?.generalSettings;
      state.currentlySelectedStream = action?.payload?.currentlySelectedStream;
      state.isValidationReq = action?.payload?.isValidationReq;
      state.streams = action?.payload?.streams;
      // state.action = action?.payload?.action;
    },
  },
});

export const { openDatasourceModal,
  closeDatasourceModal,
  addGeneralSettings,
  addSelectedDatasource,
  setSelectedStream,
  addItem,
  addStream,
  appendStreams,
  updateItemSelection,
  saveSelectedSourceTables,
  addStreams,
  saveStreamConfigs,
  deleteStream,
  isActiveStream,
  deactivateAllStreams,
  setSelectedAndActiveStream,
  updateStreamTitle,
  saveMappingConfig,
  appendSelectedDatasource,
  updateStreams,
  setActiveConfig,
  resetState,
  deleteStreamByConnectionID,
  validationOnStreamReq,
  updateStreamsByConfig,
  patchPipelineData,
  setAction,
  setIsNextBtnRequired,
  deleteStreampartition,
  checkStreamValidations,
  resetPipelineState,
  updateJoinStream,
  deleteStreamByPartitionColumnName,
} = onePlatformPipelineSlice.actions;
export default onePlatformPipelineSlice.reducer;
